import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const fmt = (v) =>
  `$${Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
};

export const track = (event, page = "", detail = "", email = "") => {
  api.post("/track", { event, page, detail, email }).catch(() => {});
};
